// extracted by mini-css-extract-plugin
export default {"tablecontainer":"CustomEventList_tablecontainer__V4dJ9","eventoptions":"CustomEventList_eventoptions__0oJMp"};